<template>
  <div class="cf-overlay" @click.self="$emit('fechar')">
    <div class="cf-modal">

      <!-- Cabeçalho -->
      <div class="cf-modal__header">
        <div>
          <h4 class="cf-modal__title">
            <i class="fas fa-tools mr-2"></i>Corrigir Dados Fiscais
          </h4>
          <small class="text-muted" v-if="nfce">
            NFC-e #{{ nfce.numero }} · Série {{ nfce.serie }}
          </small>
        </div>
        <button class="cf-btn cf-btn--light" @click="$emit('fechar')">✕</button>
      </div>

      <!-- Corpo -->
      <div class="cf-modal__body">

        <!-- Mensagem de rejeição -->
        <div v-if="rejeicao" class="cf-alert cf-alert--danger">
          <i class="fas fa-ban mr-2"></i>
          <span>
            <strong>{{ nfce.codigo_rejeicao ? `Rejeição ${nfce.codigo_rejeicao}` : 'Rejeitada' }}:</strong>
            {{ rejeicao.mensagem }}
          </span>
        </div>

        <!-- Carregando -->
        <div v-if="carregando" class="text-center py-4 text-muted">
          <span class="spinner-border spinner-border-sm mr-2"></span> Carregando itens...
        </div>

        <template v-else>
          <!-- Selector de item (quando rejeição não identificou nItem) -->
          <div v-if="itens.length > 1 && rejeicao && rejeicao.nItem == null" class="cf-form-group">
            <label class="cf-label">Item a corrigir</label>
            <select v-model="nItemSelecionado" class="cf-select">
              <option v-for="(it, i) in itens" :key="i" :value="i + 1">
                {{ i + 1 }}. {{ it.descricao }} ({{ it.quantidade }}x R${{ fmtBRL(it.valor_unitario) }})
              </option>
            </select>
          </div>

          <!-- Dados do item rejeitado -->
          <div v-if="itemAtual" class="cf-item-card">
            <div class="cf-item-card__title">
              <i class="fas fa-box mr-1"></i>
              Item {{ nItemSelecionado }}: <strong>{{ itemAtual.descricao }}</strong>
            </div>
            <div class="cf-item-card__sub">
              Qtd: {{ itemAtual.quantidade }} · Unitário: R$ {{ fmtBRL(itemAtual.valor_unitario) }} ·
              Total: R$ {{ fmtBRL(itemAtual.total) }}
            </div>
          </div>

          <!-- Formulário fiscal -->
          <div v-if="itemAtual" class="cf-fiscal-form">

            <!-- CSOSN -->
            <div class="cf-form-group">
              <label class="cf-label">
                CSOSN
                <span v-if="rejeicao && rejeicao.campo === 'CSOSN'" class="cf-badge cf-badge--danger ml-1">
                  campo rejeitado
                </span>
              </label>
              <select v-model="form.csosn" class="cf-select">
                <option
                  v-for="op in csosnOpcoes"
                  :key="op.value"
                  :value="op.value"
                >{{ op.label }}</option>
              </select>
              <small class="cf-hint">
                Para NFC-e Simples Nacional sem crédito, use <strong>102</strong>.
              </small>
            </div>

            <!-- CFOP -->
            <div class="cf-form-group">
              <label class="cf-label">
                CFOP
                <span v-if="rejeicao && rejeicao.campo === 'CFOP'" class="cf-badge cf-badge--danger ml-1">
                  campo rejeitado
                </span>
              </label>
              <input
                v-model="form.cfop"
                type="text"
                class="cf-input"
                maxlength="7"
                placeholder="ex: 5102"
              />
            </div>

            <!-- NCM -->
            <div class="cf-form-group">
              <label class="cf-label">
                NCM
                <span v-if="rejeicao && rejeicao.campo === 'NCM'" class="cf-badge cf-badge--danger ml-1">
                  campo rejeitado
                </span>
              </label>
              <input
                v-model="form.ncm"
                type="text"
                class="cf-input"
                maxlength="10"
                placeholder="ex: 22021000"
              />
            </div>

            <!-- CST PIS -->
            <div class="cf-form-group">
              <label class="cf-label">
                CST PIS
                <span v-if="rejeicao && rejeicao.campo === 'CST_PIS'" class="cf-badge cf-badge--danger ml-1">
                  campo rejeitado
                </span>
              </label>
              <select v-model="form.cst_pis" class="cf-select">
                <option value="07">07 – Operação Isenta da Contribuição</option>
                <option value="08">08 – Operação sem Incidência da Contribuição</option>
                <option value="49">49 – Outras Operações de Saída</option>
                <option value="99">99 – Outras Operações</option>
              </select>
            </div>

            <!-- CST COFINS -->
            <div class="cf-form-group">
              <label class="cf-label">
                CST COFINS
                <span v-if="rejeicao && rejeicao.campo === 'CST_COFINS'" class="cf-badge cf-badge--danger ml-1">
                  campo rejeitado
                </span>
              </label>
              <select v-model="form.cst_cofins" class="cf-select">
                <option value="07">07 – Operação Isenta da Contribuição</option>
                <option value="08">08 – Operação sem Incidência da Contribuição</option>
                <option value="49">49 – Outras Operações de Saída</option>
                <option value="99">99 – Outras Operações</option>
              </select>
            </div>

          </div>
        </template>

        <!-- Feedback -->
        <div v-if="erro"    class="cf-alert cf-alert--danger mt-2">{{ erro }}</div>
        <div v-if="sucesso" class="cf-alert cf-alert--success mt-2">{{ sucesso }}</div>

      </div>

      <!-- Rodapé -->
      <div class="cf-modal__footer">

        <button
          class="cf-btn cf-btn--secondary"
          @click="$emit('fechar')"
        >
          Cancelar
        </button>

        <button
          class="cf-btn cf-btn--primary"
          :disabled="salvando || !itemAtual"
          @click="salvarCorrecao"
        >
          <span v-if="salvando">
            <span class="spinner-border spinner-border-sm mr-1"></span>Salvando...
          </span>
          <span v-else>
            <i class="fas fa-save mr-1"></i>Salvar Correção
          </span>
        </button>

        <button
          v-if="correcaoSalva"
          class="cf-btn cf-btn--warning"
          :disabled="regenerando"
          @click="gerarEAssinar"
        >
          <span v-if="regenerando">
            <span class="spinner-border spinner-border-sm mr-1"></span>Gerando...
          </span>
          <span v-else>
            <i class="fas fa-file-code mr-1"></i>Gerar e Assinar Novamente
          </span>
        </button>

        <button
          v-if="xmlPronto"
          class="cf-btn cf-btn--success"
          :disabled="transmitindo"
          @click="transmitir"
        >
          <span v-if="transmitindo">
            <span class="spinner-border spinner-border-sm mr-1"></span>Transmitindo...
          </span>
          <span v-else>
            <i class="fas fa-paper-plane mr-1"></i>Transmitir Novamente
          </span>
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import { getElectronAPI }        from "@/plugins/desktop";
import NfceRejeicaoService       from "../services/NfceRejeicaoService";
import SyncPdvDesktopService     from "../services/SyncPdvDesktopService";

export default {
  name: "CorrigirFiscalModal",

  props: {
    /** Registro nfce_local (deve ter uuid_venda_terminal, motivo_erro, codigo_rejeicao etc.) */
    nfce: {
      type:     Object,
      required: true,
    },
  },

  emits: ["fechar", "atualizar"],

  data() {
    return {
      carregando: false,
      salvando:   false,
      regenerando: false,
      transmitindo: false,
      erro:    null,
      sucesso: null,
      itens:   [],
      nItemSelecionado: 1,
      form: {
        csosn:     "102",
        cfop:      "",
        ncm:       "",
        cst_pis:   "07",
        cst_cofins: "07",
      },
      correcaoSalva: false,
      xmlPronto:     false,
      csosnOpcoes:   NfceRejeicaoService.csosnSugeridos(),
    };
  },

  computed: {
    rejeicao() {
      const motivo = this.nfce.motivo_erro || this.nfce.ultimo_erro || null;
      if (!motivo) return null;
      return NfceRejeicaoService.parse(motivo);
    },

    itemAtual() {
      if (!this.itens.length) return null;
      const idx = Math.max(0, Number(this.nItemSelecionado) - 1);
      return this.itens[idx] ?? this.itens[0] ?? null;
    },
  },

  async created() {
    await this._carregarItens();
  },

  methods: {
    fmtBRL(v) {
      return Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    async _carregarItens() {
      this.carregando = true;
      try {
        const api  = getElectronAPI();
        this.itens = (await api.nfce.getItens(this.nfce.uuid_venda_terminal)) || [];

        // Se a rejeição identificou o nItem, pré-seleciona e preenche o form
        const r = this.rejeicao;
        if (r && r.nItem != null) {
          this.nItemSelecionado = r.nItem;
        } else {
          this.nItemSelecionado = 1;
        }

        this._preencherFormComItem();
      } catch (e) {
        this.erro = `Erro ao carregar itens: ${e.message}`;
      } finally {
        this.carregando = false;
      }
    },

    _preencherFormComItem() {
      const item = this.itemAtual;
      if (!item) return;

      // Tenta extrair dados fiscais do payload_json
      let fiscal = {};
      try {
        const p = item.payload_json ? JSON.parse(item.payload_json) : {};
        fiscal  = p.fiscal ?? p._fiscal ?? p.dados_fiscais ?? p;
      } catch (_) { /* ignore parse errors */ }

      this.form.csosn     = item.cst_csosn_codigo  || fiscal.csosn     || "102";
      this.form.cfop      = item.cfop_codigo        || fiscal.cfop      || "";
      this.form.ncm       = item.ncm_codigo         || fiscal.ncm       || "";
      this.form.cst_pis   = item.cst_pis_codigo     || fiscal.cst_pis   || "07";
      this.form.cst_cofins = item.cst_cofins_codigo || fiscal.cst_cofins || "07";

      // Se modelo 65 e CSOSN for 1 (indevido), sugere 102
      const modelo = Number(this.nfce.modelo || 65);
      if (modelo === 65 && ["1", "01", "001"].includes(String(this.form.csosn))) {
        this.form.csosn = "102";
      }
    },

    async salvarCorrecao() {
      this.salvando = true;
      this.erro     = null;
      this.sucesso  = null;
      try {
        const api = getElectronAPI();

        // 1. Corrige os dados fiscais do item
        await api.nfce.corrigirItemFiscal(
          this.nfce.uuid_venda_terminal,
          this.nItemSelecionado,
          {
            csosn:      this.form.csosn     || null,
            cfop:       this.form.cfop      || null,
            ncm:        this.form.ncm       || null,
            cst_pis:    this.form.cst_pis   || null,
            cst_cofins: this.form.cst_cofins || null,
          }
        );

        // 2. Prepara a NFC-e para regerar (limpa xml, status → pendente_xml)
        await api.nfce.prepararParaRegerarXml(this.nfce.uuid_venda_terminal);

        this.sucesso      = "Correção salva. Agora gere e assine o XML novamente.";
        this.correcaoSalva = true;
        this.xmlPronto    = false;
        this.$emit("atualizar");
      } catch (e) {
        this.erro = `Erro ao salvar correção: ${e.message}`;
      } finally {
        this.salvando = false;
      }
    },

    async gerarEAssinar() {
      this.regenerando = true;
      this.erro        = null;
      this.sucesso     = null;
      try {
        const api    = getElectronAPI();
        const uuid   = this.nfce.uuid_venda_terminal;

        // Gerar XML
        await api.nfce.gerarXml(uuid);

        // Assinar XML
        await api.nfce.assinarXml(uuid);

        this.sucesso   = "XML gerado e assinado com sucesso! Agora transmita novamente.";
        this.xmlPronto = true;
        this.$emit("atualizar");
      } catch (e) {
        this.erro = `Erro ao gerar/assinar XML: ${e.message}`;
      } finally {
        this.regenerando = false;
      }
    },

    async transmitir() {
      this.transmitindo = true;
      this.erro         = null;
      this.sucesso      = null;
      try {
        const resultado = await SyncPdvDesktopService.transmitirNfce(
          this.nfce.uuid_venda_terminal
        );
        const status = resultado?.status;
        if (status === "autorizada" || status === "ja_autorizada") {
          this.sucesso = `NFC-e autorizada! Protocolo: ${resultado.protocolo || "—"}`;
          this.xmlPronto     = false;
          this.correcaoSalva = false;
          this.$emit("atualizar");
        } else if (status === "rejeitada") {
          this.erro = `Ainda rejeitada: ${resultado.motivo || resultado.codigo || "sem motivo"}`;
          this.$emit("atualizar");
        } else {
          this.erro = `Transmissão com status inesperado: ${status}`;
        }
      } catch (e) {
        this.erro = `Erro ao transmitir: ${e.message}`;
      } finally {
        this.transmitindo = false;
      }
    },
  },
};
</script>

<style scoped>
.cf-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.cf-modal {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0,0,0,.22);
  width: 560px;
  max-width: 96vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cf-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem 1.5rem 1rem;
  border-bottom: 1px solid #dee2e6;
}

.cf-modal__title {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0;
  color: #212529;
}

.cf-modal__body {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
  flex: 1;
}

.cf-modal__footer {
  display: flex;
  gap: .5rem;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  flex-wrap: wrap;
}

/* Alerts */
.cf-alert {
  padding: .65rem 1rem;
  border-radius: 7px;
  font-size: .875rem;
  margin-bottom: .75rem;
  display: flex;
  align-items: flex-start;
  gap: .4rem;
}
.cf-alert--danger  { background: #fff5f5; border: 1px solid #f8d7da; color: #842029; }
.cf-alert--success { background: #f0fdf4; border: 1px solid #bbf7d0; color: #166534; }

/* Item card */
.cf-item-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: .85rem 1rem;
  margin-bottom: 1rem;
}
.cf-item-card__title {
  font-weight: 600;
  font-size: .9rem;
  color: #212529;
  margin-bottom: .25rem;
}
.cf-item-card__sub {
  font-size: .8rem;
  color: #6c757d;
}

/* Form */
.cf-fiscal-form { display: flex; flex-direction: column; gap: .75rem; }
.cf-form-group  { display: flex; flex-direction: column; gap: .3rem; }
.cf-label       { font-size: .8rem; font-weight: 600; color: #495057; display: flex; align-items: center; }
.cf-input, .cf-select {
  padding: .45rem .75rem;
  border: 1.5px solid #ced4da;
  border-radius: 7px;
  font-size: .875rem;
  color: #212529;
  background: #fff;
  width: 100%;
  outline: none;
  transition: border-color .15s;
}
.cf-input:focus, .cf-select:focus { border-color: var(--primary-color, #ee7361); }
.cf-hint { font-size: .75rem; color: #6c757d; }

/* Badges */
.cf-badge {
  display: inline-block;
  font-size: .7rem;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 10px;
}
.cf-badge--danger { background: #f8d7da; color: #842029; }

/* Buttons */
.cf-btn {
  padding: .5rem 1.1rem;
  border-radius: 7px;
  font-size: .87rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  display: inline-flex;
  align-items: center;
  transition: opacity .15s;
}
.cf-btn:disabled    { opacity: .55; cursor: not-allowed; }
.cf-btn--primary    { background: var(--primary-color, #ee7361); color: #fff; border: 1.5px solid var(--primary-color, #ee7361); }
.cf-btn--secondary  { background: #f1f3f5; color: #495057; border: 1.5px solid #ced4da; }
.cf-btn--warning    { background: #fff3cd; color: #856404; border: 1.5px solid #ffc107; }
.cf-btn--success    { background: #198754; color: #fff; border: 1.5px solid #198754; }
.cf-btn--light      { background: transparent; color: #6c757d; border: none; font-size: 1rem; }

.mr-1 { margin-right: .25rem; }
.mr-2 { margin-right: .5rem; }
.ml-1 { margin-left: .25rem; }
.mt-2 { margin-top: .5rem; }
</style>
